// extracted by mini-css-extract-plugin
export default {"tx":"_8245d3f97a","line":"_140bcb62c3"};